import { ControlType, FormItemType } from '../../../Enums'

export function createTab(mode, formId, tabNames) {
  const newTabPanel = {}

  newTabPanel.Name = 'Tab Panel'
  newTabPanel.Type = 'Tab'
  newTabPanel.FormItemType = FormItemType.Tab
  newTabPanel.Tooltip = ''
  newTabPanel.ControlType = ControlType.Tabs
  newTabPanel.FormId = formId

  if (mode === 'import') {
    const tabs =
      tabNames?.map((tabName, index) => ({
        TempId: index + 1,
        Value: tabName,
        Order: index,
      })) ?? []
    newTabPanel.Tabs = tabs
  } else {
    newTabPanel.Tabs = [
      { TempId: 1, Value: 'Tab 1', Order: 0 },
      { TempId: 2, Value: 'Tab 2', Order: 1 },
    ]
  }

  return newTabPanel
}
